import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { DialogContent, Modal, Backdrop } from '@material-ui/core';

import Header from '../components/layout/header/header';
import Footer from '../components/layout/footer/footer';
// import HubspotModal from '../components/formModal/formModal';
import SEO from '../components/seo/seo';
import FriendlyReminderOverlay from '../components/layout/friendlyReminderOverlay/friendlyReminderOverlay';
import StrapiText from '../components/text/strapi-markdown-text-snippet';
import { LocationCard } from '../components/locationCard/locationCard';
import StrapiFullWidthContent from '../components/full-width-content/strapi-full-width-content';
import StrapiSplitColumn from '../components/split-column/strapi-split-column';
import GenericForm from '../components/form/form';
import { StateToAbbrArray } from '../shared/stateToAbbr';
// import { Store } from '../../models/dataTypes/store';
import { FormData, ContactUsFormData } from '../models/dataTypes/formData';
import { isEmailValid, isNameValid, isPhoneValid } from '../services/util/validators';
import { OptInService } from '../services/formService';

import { StateLandingPageQuery } from '../models/strapi/stateLandingPageQuery';
import { LayoutProps } from '../models/layout';

import * as styles from './state.module.scss';

import { CannabisWithConfidenceLogo, CloseWhite } from '../assets/svg';

interface Props extends LayoutProps {
    pageContext: {
        data: StateLandingPageQuery;
        stateAbbrv: string;
    };
}

const StateTemplate = (props: Props) => {
    const [modalShowMailingList, setModalShowMailingList] = React.useState(false);
    const [modalShowContact, setModalShowContact] = React.useState(false);
    const optin = new OptInService();
    const strapiData = props.pageContext.data;

    const contactUsModal = () => setModalShowContact(true);
    const mailingListModal = () => setModalShowMailingList(true);
    const functions = {
        contactUsModal,
        mailingListModal
    };

    const thisState = (stateAbbrv: string) => {
        const currentStateObj = StateToAbbrArray.find((dispoState) => {
            if (dispoState.abbreviation === stateAbbrv) {
                return dispoState;
            }
        });
        if (currentStateObj) {
            return [{ id: currentStateObj.name, label: currentStateObj.name, disabled: true }];
        } else {
            return [stateAbbrv];
        }
    };

    const stateDispensaries = (dispoList) =>
        dispoList.map((dispo, i) => {
            return {
                id: i,
                label: dispo.name
            };
        });

    const submitContactForm = async (formData: ContactUsFormData) => {
        return await optin.submitContactForm(formData);
    };

    const submitMailingForm = async (formData: FormData) => {
        if (
            (formData.optInMethod.includes('Text') &&
                (!formData.phone || !isPhoneValid(formData.phone))) ||
            !formData.optIn
        ) {
            return await optin.submitForm(null, null, true);
        }
        return await optin.submitForm({
            ...formData,
            state: process.env.STATE_ABBREVIATION || ''
        });
    };

    return (
        <div>
            {props.pageContext.data && props.pageContext.data.friendly_reminder ? (
                <FriendlyReminderOverlay
                    reminderOverlayOpen={props.reminderOverlayOpen}
                    toggleReminderOverlay={props.toggleFriendlyOverlay}
                    data={props.pageContext.data.friendly_reminder}
                />
            ) : null}
            <SEO
                title={
                    strapiData.websiteSeo && strapiData.websiteSeo.title
                        ? strapiData.websiteSeo.title
                        : `Curaleaf ${props.pageContext.stateAbbrv}`
                }
            />
            <Header
                siteTitle={`Curaleaf ${props.pageContext.stateAbbrv}`}
                mobileMenuOpen={props.mobileMenuOpen}
                toggleMobileMenu={props.toggleMobileMenu}
                data={strapiData.header}
                closeAllMenus={props.closeAllMenus}
                usingMouse={props.usingMouse}
                setMobileMenu={props.setMobileMenu}
                alertBannerData={strapiData.headerBanner}
            />
            <div className='content-container'>
                <div className={styles.banner}>
                    <StrapiFullWidthContent
                        data={strapiData.full_width_content_banner}
                        isMobile={props.isMobile}
                        overlay={false}
                    />
                </div>
                <div className={styles.locationContainer}>
                    <div
                        id={strapiData.dispensary_list_anchorTag}
                        className={styles.anchorOffset}
                    />
                    <StrapiText
                        data={{
                            font: 'tradeGothic',
                            fontColor: 'teal',
                            textAlign: 'center',
                            value: strapiData.dispensary_list_title
                        }}
                    />
                    <div className={styles.locationRow}>
                        {strapiData.dispensary_lists.map((disp, i) => {
                            return (
                                <LocationCard
                                    key={i}
                                    dispensary={disp}
                                    usingMouse={props.usingMouse}
                                />
                            );
                        })}
                    </div>
                </div>
                <div
                    id={strapiData.split_column_patientRegistry.anchorTag}
                    className={styles.anchorOffset}
                />
                <StrapiSplitColumn
                    data={strapiData.split_column_patientRegistry}
                    usingMouse={props.usingMouse}
                    onClickFunctions={functions}
                />
                <div id={strapiData.mission.anchorTag} className={styles.anchorOffset} />
                <div className={styles.cannabisWithConfidence}>
                    <div className={styles.cannabisWithConfidenceTitle}>
                        <StrapiText
                            data={{
                                font: 'tradeGothic',
                                fontColor: 'white',
                                textAlign: 'center',
                                value: strapiData.mission.title
                            }}
                        />
                    </div>
                    <div className={styles.cannabisWithConfidenceWhitePage}>
                        <div className={styles.logo}>
                            <CannabisWithConfidenceLogo />
                        </div>
                        <Row>
                            <Col xs={12} sm={6} lg>
                                <StrapiText
                                    data={{
                                        font: 'tradeGothic',
                                        fontColor: 'black',
                                        textAlign: 'left',
                                        value: strapiData.mission.columnLeft
                                    }}
                                />
                            </Col>
                            <Col xs={12} sm={6} lg>
                                <StrapiText
                                    data={{
                                        font: 'tradeGothic',
                                        fontColor: 'black',
                                        textAlign: 'left',
                                        value: strapiData.mission.columnRight
                                    }}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className={styles.banner + ` ${styles.spacerBanner}`}>
                    <StrapiFullWidthContent data={strapiData.full_width_content_divider} />
                </div>
                <div
                    id={strapiData.split_column_askUs_stayConnected.anchorTag}
                    className={styles.anchorOffset}
                />
                {modalShowContact || modalShowMailingList ? (
                    <Modal
                        aria-labelledby='contained-modal-title-vcenter'
                        className={styles.modalContainer}
                        open={modalShowContact || modalShowMailingList}
                        onClose={() => {
                            modalShowContact
                                ? setModalShowContact(false)
                                : setModalShowMailingList(false);
                        }}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500
                        }}>
                        <DialogContent className={styles.formModal}>
                            <Col lg={12} className={styles.closeButtons}>
                                <div className={styles.closeIconDiv}>
                                    <CloseWhite
                                        className={styles.closeIcon}
                                        onClick={() => {
                                            modalShowContact
                                                ? setModalShowContact(false)
                                                : setModalShowMailingList(false);
                                        }}
                                    />
                                </div>
                            </Col>
                            <Col lg={12} className={styles.formComponent}>
                                {modalShowContact ? (
                                    <GenericForm
                                        eventName='contactUsFormSubmission'
                                        formTitle='Contact Us'
                                        formSubtitle='For questions regarding orders or if you are a patient and would like to connect with a local Curaleaf dispensary, please visit Curaleaf in your state to reach us most directly.'
                                        fields={[
                                            {
                                                type: 'text',
                                                size: 'halfLeft',
                                                label: 'First Name',
                                                fieldName: 'firstName',
                                                required: true,
                                                validator: isNameValid
                                            },
                                            {
                                                type: 'text',
                                                size: 'halfRight',
                                                label: 'Last Name',
                                                fieldName: 'lastName',
                                                required: true,
                                                validator: isNameValid
                                            },
                                            {
                                                type: 'text',
                                                size: 'halfLeft',
                                                label: 'Email',
                                                fieldName: 'email',
                                                required: true,
                                                validator: isEmailValid
                                            },
                                            {
                                                type: 'text',
                                                size: 'halfRight',
                                                label: 'Mobile Phone Number',
                                                fieldName: 'phone',
                                                required: false,
                                                validator: isPhoneValid
                                            },
                                            {
                                                type: 'dropdown',
                                                size: 'full',
                                                label: 'What dispensary will you visit?',
                                                fieldName: 'dispensary',
                                                required: false,
                                                placeholder: 'Please Select a Dispensary',
                                                options: stateDispensaries(
                                                    props.pageContext.data.dispensary_lists
                                                ),
                                                validator: (state: string) => {
                                                    if (state) {
                                                        return true;
                                                    } else {
                                                        return false;
                                                    }
                                                }
                                            },
                                            {
                                                type: 'dropdown',
                                                size: 'full',
                                                label: 'Please Identify a topic so we may better assist you.',
                                                fieldName: 'topic',
                                                required: true,
                                                placeholder: 'Please Select',
                                                options: [
                                                    {
                                                        id: 'General Feedback',
                                                        label: 'General Feedback'
                                                    },
                                                    {
                                                        id: 'Product Question',
                                                        label: 'Product Question'
                                                    },
                                                    {
                                                        id: 'Promotions',
                                                        label: 'Promotions'
                                                    },
                                                    {
                                                        id: 'Store Info',
                                                        label: 'Store Info'
                                                    },
                                                    {
                                                        id: 'Online Orders',
                                                        label: 'Online Orders'
                                                    },
                                                    {
                                                        id: 'Media/PR Request',
                                                        label: 'Media/PR Request'
                                                    },
                                                    {
                                                        id: 'Sales/Vendor Support',
                                                        label: 'Sales/Vendor Support'
                                                    },
                                                    {
                                                        id: 'Investor Relations',
                                                        label: 'Investor Relations'
                                                    },
                                                    {
                                                        id: 'Other',
                                                        label: 'Other'
                                                    }
                                                ],
                                                validator: (topic: string) => {
                                                    if (topic) {
                                                        return true;
                                                    } else {
                                                        return false;
                                                    }
                                                }
                                            },
                                            {
                                                type: 'longText',
                                                size: 'full',
                                                label: 'Please provide our team with some details.',
                                                fieldName: 'topicDescription',
                                                required: true,
                                                validator: (description: string) => {
                                                    if (description) {
                                                        return true;
                                                    } else {
                                                        return false;
                                                    }
                                                }
                                            },
                                            {
                                                type: 'checkbox',
                                                size: 'full',
                                                label: null,
                                                fieldName: 'optIn',
                                                required: false,
                                                options: [
                                                    'I want to receive marketing materials from Curaleaf and subsidiary brands.'
                                                ],
                                                multiSelect: false,
                                                validator: (optIn: boolean) => {
                                                    return optIn;
                                                },
                                                defaultValue: false
                                            }
                                        ]}
                                        submitButton='Submit'
                                        confirmation={{
                                            title: 'We’re so glad you joined us!',
                                            content:
                                                'You’ll receive your first email within the next 24 hours. Then look for exclusive promotions, exciting cannabis learning content, and more each week!',
                                            placement: 'modal'
                                        }}
                                        closeFunc={() => setModalShowContact(false)}
                                        submitFunc={submitContactForm}
                                        isMobile={props.isMobile}
                                        usingMouse={props.usingMouse}
                                    />
                                ) : (
                                    <GenericForm
                                        eventName='mailingOptIn'
                                        formTitle='Sign Up For Our Mailing List'
                                        formSubtitle='Join our compassionate care community to get emails and texts from Curaleaf about product releases, event announcements, and helpful tips.'
                                        fields={[
                                            {
                                                type: 'text',
                                                size: 'halfLeft',
                                                label: 'First Name',
                                                fieldName: 'firstName',
                                                required: true,
                                                validator: isNameValid
                                            },
                                            {
                                                type: 'text',
                                                size: 'halfRight',
                                                label: 'Last Name',
                                                fieldName: 'lastName',
                                                required: true,
                                                validator: isNameValid
                                            },
                                            {
                                                type: 'text',
                                                size: 'halfLeft',
                                                label: 'Email',
                                                fieldName: 'email',
                                                required: true,
                                                validator: isEmailValid
                                            },
                                            {
                                                type: 'text',
                                                size: 'halfRight',
                                                label: 'Mobile Phone Number',
                                                fieldName: 'phone',
                                                required: false,
                                                validator: isPhoneValid
                                            },
                                            {
                                                type: 'radio',
                                                size: 'full',
                                                label: 'What are you interested in?',
                                                fieldName: 'cardStatus',
                                                required: true,
                                                options: [
                                                    {
                                                        id: 'med',
                                                        label: 'I have a Medical ID Card, I am shopping for Medical Cannabis'
                                                    },
                                                    {
                                                        id: 'rec',
                                                        label: 'I am shopping for Recreational or Adult Use Cannabis'
                                                    },
                                                    {
                                                        id: 'interested',
                                                        label: 'I do not have a Medical ID Card, I am interested in obtaining one'
                                                    }
                                                ],
                                                validator: (input: string) => {
                                                    if (input) {
                                                        return true;
                                                    } else {
                                                        return false;
                                                    }
                                                }
                                            },
                                            {
                                                type: 'dropdown',
                                                size: 'full',
                                                label: 'What dispensary will you visit?',
                                                fieldName: 'dispensary',
                                                required: false,
                                                placeholder: 'Please Select a Dispensary',
                                                options: stateDispensaries(
                                                    props.pageContext.data.dispensary_lists
                                                ),
                                                validator: (state: string) => {
                                                    if (state) {
                                                        return true;
                                                    } else {
                                                        return false;
                                                    }
                                                }
                                            },
                                            {
                                                type: 'checkbox',
                                                size: 'full',
                                                label: 'Preferred Method(s) of Communication',
                                                fieldName: 'optInMethod',
                                                required: true,
                                                options: ['Email', 'Text'],
                                                indentOptions: true,
                                                multiSelect: true,
                                                defaultValue: ['Email', 'Text']
                                            },
                                            {
                                                type: 'checkbox',
                                                size: 'full',
                                                label: null,
                                                fieldName: 'optIn',
                                                required: true,
                                                //eslint-disable-next-line
                                                options: [
                                                    'Yes, I agree and provide express consent for Curaleaf and its affiliates to contact me concerning its products and services AND for receiving marketing communications on upcoming specials and promotions at the phone number provided, which I represent is my own, including through the use of automatic dialing and/or text messaging (SMS/MMS), and that this express consent is being provided even in the event that my phone number is otherwise registered with a corporate, state, or national Do Not Call registry.  I understand that standard text messaging rates may apply to any messages received from Curaleaf.  I also understand that I may revoke this permission and discontinue my participation in Curaleaf’s text message marketing service by replying “STOP” or "END" to a text message received from Curaleaf.  I agree not to hold Curaleaf liable for any electronic messaging charges or fees generated by this service.  I understand that I do not have to agree to be contacted in order to purchase any goods from Curaleaf, and that my consent to being contacted as described herein is voluntary.'
                                                ],
                                                multiSelect: false,
                                                validator: (optIn: boolean) => {
                                                    return optIn;
                                                },
                                                defaultValue: false
                                            }
                                        ]}
                                        submitButton='Submit'
                                        confirmation={{
                                            title: 'We’re so glad you joined us!',
                                            content:
                                                'You’ll receive your first email within the next 24 hours. Then look for exclusive promotions, exciting cannabis learning content, and more each week!',
                                            placement: 'modal'
                                        }}
                                        closeFunc={() => setModalShowMailingList(false)}
                                        submitFunc={submitMailingForm}
                                        isMobile={props.isMobile}
                                        usingMouse={props.usingMouse}
                                    />
                                )}
                            </Col>
                        </DialogContent>
                    </Modal>
                ) : null}
                <StrapiSplitColumn
                    data={strapiData.split_column_askUs_stayConnected}
                    usingMouse={props.usingMouse}
                    onClickFunctions={functions}
                />
                {strapiData.split_column_workWithUs ? (
                    <StrapiSplitColumn
                        data={strapiData.split_column_workWithUs}
                        usingMouse={props.usingMouse}
                        onClickFunctions={functions}
                    />
                ) : null}
            </div>
            <Footer data={strapiData.footer} usingMouse={props.usingMouse} />
        </div>
    );
};

export default StateTemplate;
